import { render, staticRenderFns } from "./PEmpty.vue?vue&type=template&id=47ac9d29&scoped=true&"
import script from "./PEmpty.vue?vue&type=script&lang=js&"
export * from "./PEmpty.vue?vue&type=script&lang=js&"
import style0 from "./PEmpty.vue?vue&type=style&index=0&id=47ac9d29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac9d29",
  null
  
)

export default component.exports